import { useEffect, useState } from "react";
import { Vote, SkipForward, Users } from "lucide-react";
import { Avatar, vibrate } from "../ui";
import { turnOrder } from "../game";

const R = 54;
const C = 2 * Math.PI * R;

const Timer = ({ left, total }) => (
  <div className={`timer${left <= 5 ? " urgent" : ""}`} data-testid="turn-timer">
    <svg viewBox="0 0 120 120">
      <circle cx="60" cy="60" r={R} className="timer-track" />
      <circle cx="60" cy="60" r={R} className="timer-bar" strokeDasharray={C} strokeDashoffset={C * (1 - left / total)} />
    </svg>
    <span data-testid="timer-seconds">{left}</span>
  </div>
);

export default function Round({ game, settings, onVote, play }) {
  const order = turnOrder(game.players, game.starter);
  const [turn, setTurn] = useState(0);
  const [left, setLeft] = useState(settings.timerSecs);
  const alive = order.length;
  const dead = game.players.filter((p) => !p.alive);
  const done = turn >= order.length;

  useEffect(() => {
    if (!settings.timerOn || done) return;
    setLeft(settings.timerSecs);
    const id = setInterval(() => setLeft((l) => Math.max(0, l - 1)), 1000);
    return () => clearInterval(id);
  }, [turn, settings.timerOn, settings.timerSecs, done]);

  useEffect(() => {
    if (!settings.timerOn || done) return;
    if (left > 0 && left <= 3) play("tick");
    if (left === 0) { play("time"); vibrate([120, 60, 120]); }
  }, [left]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="screen">
      <div className="round-head">
        <h1 className="screen-title" data-testid="round-number">Ronda {game.round}</h1>
        <span className="badge" data-testid="alive-count"><Users size={14} /> {alive} vivos</span>
      </div>

      <section className="glass section starter" data-testid="starter-info">
        <span className="muted">Empieza</span>
        <span className="pass-name"><Avatar name={game.starter} size="lg" /> {game.starter}</span>
        <p className="muted small">Cada jugador dice una palabra relacionada, sin revelar la secreta.</p>
      </section>

      {settings.timerOn && !done && <Timer left={left} total={settings.timerSecs} />}

      <ol className="turns" data-testid="turn-order">
        {order.map((n, i) => (
          <li key={n} className={i === turn ? "current" : i < turn ? "done" : ""} data-testid={`turn-item-${i}`}>
            <span className="turn-num">{i + 1}</span>
            <Avatar name={n} size="sm" />
            <span className="grow">{n}</span>
            {i === turn && <span className="turn-tag">Su turno</span>}
          </li>
        ))}
      </ol>

      {dead.length > 0 && (
        <div className="dead-row" data-testid="eliminated-list">
          <span className="muted small">Eliminados:</span>
          {dead.map((p) => <span key={p.name} className="dead-chip"><Avatar name={p.name} size="xs" dead /> {p.name}</span>)}
        </div>
      )}

      <div className="actions row">
        {!done && (
          <button className="btn btn-ghost btn-xl" onClick={() => { play("tap"); setTurn((t) => t + 1); }} data-testid="next-turn-btn">
            <SkipForward size={20} /> Siguiente
          </button>
        )}
        <button className="btn btn-primary btn-xl grow" onClick={onVote} data-testid="go-vote-btn"><Vote size={22} /> Votar</button>
      </div>
    </div>
  );
}
